
export const api = {
	host: process.env.NODE_ENV == "production" ? 'https://api.mercuriusdata.com/v1' : 'https://dev.api.mercuriusdata.com/v1',
	base: process.env.NODE_ENV == "production" ? 'https://api.mercuriusdata.com' : 'https://dev.api.mercuriusdata.com',
}
